import { useEffect } from 'react'
import { X } from 'lucide-react'
import { type AdminAsset } from '../lib/api'
import FileManagerPanel from './FileManagerPanel'

interface AssetPickerModalProps {
  onSelect: (url: string) => void
  onClose: () => void
  feature?: string
}

export default function AssetPickerModal({ onSelect, onClose, feature }: AssetPickerModalProps) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose() }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [onClose])

  const handleSelect = (asset: AdminAsset) => {
    onSelect(asset.url)
    onClose()
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/70" onClick={onClose} />
      <div className="relative z-10 bg-zinc-900 rounded-lg border border-zinc-800 w-full max-w-3xl mx-4 flex flex-col h-[80vh]">
        {/* Header */}
        <div className="flex items-center justify-between px-4 py-3 border-b border-zinc-800 flex-shrink-0">
          <h2 className="text-white font-semibold text-sm">Pilih Gambar</h2>
          <button type="button" onClick={onClose} className="text-zinc-400 hover:text-white transition-colors">
            <X size={18} />
          </button>
        </div>

        {/* File Manager Panel */}
        <div className="flex flex-1 min-h-0 overflow-hidden">
          <FileManagerPanel mode="picker" onSelect={handleSelect} feature={feature} />
        </div>
      </div>
    </div>
  )
}
